class FormOffre {
  public modal: any;
  public closeBtn: any;
  public closeButton: any;
  public messageContainer: any;
  public overlay: any;

  constructor() {
    this.modal = null;
    this.closeBtn = null;
    this.closeButton = null;
    this.messageContainer = null;
    this.overlay = null;
    this._init();
  }

  _init() {
    this.modal = document.getElementById('successModal');

    if (!this.modal) {
      console.warn('Modal non trouvé');
      return;
    }

    this.closeBtn = this.modal.querySelector('.form-offre__close');
    this.closeButton = this.modal.querySelector('.form-offre__closed');
    this.overlay = this.modal.querySelector('.form-offre__overlay');
    this.messageContainer = this.modal.querySelector('.form-offre__info');

    // Écoute tous les types de réponse CF7
    document.addEventListener('wpcf7mailsent', e => this.handleMessage(e));
    document.addEventListener('wpcf7mailfailed', e => this.handleMessage(e));
    document.addEventListener('wpcf7spam', e => this.handleMessage(e));
    document.addEventListener('wpcf7invalid', e => this.handleMessage(e));

    // Fermer le modal
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.hideModal());
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.hideModal());
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.hideModal());
    }

    window.addEventListener('click', e => {
      if (e.target === this.modal) {
        this.hideModal();
      }
    });
  }

  handleMessage(event) {
    setTimeout(() => {
      const responseEl = document.querySelector('.screen-reader-response p');

      if (responseEl && this.messageContainer) {
        const message = responseEl.textContent?.trim();
        if (message) {
          this.messageContainer.textContent = message;
          this.showModal();
        }
      }
    }, 50);
  }

  showModal() {
    this.modal.style.display = 'block'; // Affiche le modal
  }

  hideModal() {
    this.modal.style.display = 'none'; // Masque le modal
  }
}

export const formOffre = new FormOffre();
